// extracted by mini-css-extract-plugin
export default {"container":"SubtitleTypeA_container__6u54F","title":"SubtitleTypeA_title__Pg14v","text":"SubtitleTypeA_text__q+NSC"};